<template>
  <div class="position-relative carousel-custom-listing-detail">
    <div
      class="fav-botton"
      v-if="showFavButton"
      @click="favorite()"
      
      v-bind:class="{ disabled: DisableAction }"
    >
      <IconFavoriteBorder v-if="!fav" v-b-tooltip.hover :title="$t('Favorites')"/>
      <FavoriteIcon v-else  v-b-tooltip.hover :title="$t('Favorites')"/>
    </div>
    <b-carousel
      
      id="carousel-home"
      v-model="slide"
      :interval="5000"
      indicators
      background="#FFFFFF"
      style="text-shadow: 1px 1px 2px #333;"
      controls
      img-height="400"
      
    >
   
      <b-carousel-slide v-for="(imageObj, key) in imageObjs" :key="key" img-height="400" >
        <template v-slot:img >
          <a class="carousel-link" :href="imageObj.link" target="_new" id="imageSlide" @click="updateHitBanner(imageObj)" v-if="imageObj.link!='#'">
            <b-img
              class="d-block w-100"
              :width="imageWidth"
              :height="imageHeight"
              :src="imageObj.imageUrl"
              :alt="imageObj.altTitle || 'image slot'"
            />
            <div class="text-carousel" v-if="imageObj.boldText||imageObj.description">
              <span>
                <span class="text-bold">{{imageObj.boldText}}</span>
                {{imageObj.description}}
              </span>
            </div>
          </a>
          <a class="carousel-link" v-viewer id="imageSlide" v-if="imageObj.link=='#'" style="cursor:pointer">
            <b-img
              class="d-block w-100"
              :width="imageWidth"
              :height="imageHeight"
              :src="imageObj.imageUrl"
              :alt="imageObj.altTitle || 'image slot'"
            />
            <div class="text-carousel" v-if="imageObj.boldText||imageObj.description">
              <span>
                <span class="text-bold">{{imageObj.boldText}}</span>
                {{imageObj.description}}
              </span>
            </div>
          </a>
          
          
         
        </template>
      </b-carousel-slide>
      
    </b-carousel>
    <div class="position-index" v-if="positionIndex">
      <span>{{ slide + 1 }} of {{ imageObjs.length }}</span>
    </div>
    <div cols="12" class="mobile-price-detail d-flex d-lg-none" v-if="price">
      <span>{{price ? price.toLocaleString("th-TH") : ''}} {{ $t('baht') }}</span>
      <div class="mobile-favorite" @click="favorite">
        <IconFavoriteBorder v-if="!isFavorite" />
        <FavoriteIcon v-else />
      </div>
    </div>
    <div class="agency-logo" v-if="agency_profile_image"
						:style="{ backgroundImage: 'url(' + agency_profile_image + ')' }"
				></div>
    <b-toast id="favourite-toast" variant="warning" solid ref="favourite-toast">
      <template v-slot:toast-title>
        <div class="d-flex flex-grow-1 align-items-baseline">
          <b-img blank blank-color="#dc3545" class="mr-2" width="12" height="12" :alt="$t('Advertise with us Buy-Sell')"></b-img>
          <strong class="mr-auto">{{$t('favourite.title')}}</strong>
        </div>
      </template>
      {{$t('favourite.errLogin')}}
    </b-toast>
  </div>
</template>

<script>
import IconFavoriteBorder from "vue-material-design-icons/HeartOutline.vue";
import FavoriteIcon from "vue-material-design-icons/Heart.vue";
import { mapActions, mapGetters } from "vuex";
import 'viewerjs/dist/viewer.css'
  // import Viewer from "v-viewer/src/component.vue"
export default {
  name: "slider-listing-detail",
  components: {
    IconFavoriteBorder,
    FavoriteIcon,
    // Viewer
  },
  props: {
    imageObjs: {
      type: Array,
      default: () => [
        
      ]
    },
    showFavButton: Boolean,
    imageWidth: String,
    imageHeight: String,
    disableAction: Boolean,
    isFavorite:{
      type:Boolean,
      default:false
    },
    positionIndex: {
      type: Boolean,
      default: false
    },
    listingID: {
      type: Number,
      default: 0
    },
    price: {
      type: Number,
      default: 0
    },
    agency_profile_image:{
      type: String,
      default: null
    }
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      itemFavourite: null,
      fav:false,
      DisableAction: this.disableAction !== null ? this.disableAction : false
    };
  },
  watch: {
    imageObjs: function(val) {
      this.slide = 0
    },
  },
  created() {
      this.fav=this.isFavorite;  
  },
  methods: {
    ...mapActions("AdsController", ["CLICK_BANNERADS"]),
    updateHitBanner(item) {
      if(item.id) {
        this.CLICK_BANNERADS(item.id)
      }
    },
    favorite() {
      if(!this.$root.isAuthenticated) return this.$refs['favourite-toast'].show()
      this.fav = !this.fav;
      if(this.fav) {
        this.$emit("createFavourites", this.listingID)
      }
      else {
        this.$emit("deleteFavourites", this.listingID)
      }
    }
  }
};
</script>
<style lang="scss">
@import "style.scss";
</style>